import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShellComponent } from './shared/layout/shell/shell.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [ShellComponent, RouterOutlet],
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	title = 'cover-update-front';
}
